import { IProjectsUpsellRequestSources } from '.'

export const ProjectsUpsellRequestSources: IProjectsUpsellRequestSources = {
  budgetStep: 'Project creation wizard, fixed time budget step',
  financialDetailsStep: 'Project creation wizard, financial details step',
  flexibleTracking: 'Flexible Tracking upsell modal step',
  import: 'Project importer upsell modal',
  overview: 'Project overview upsell landing',
  spending: 'Project spending table upsell state',
  tasks: 'Project tasks table upsell state',
  tasksCore: 'Tasks core upsell modal',
  clients: 'Project clients table upsell state',
  contributors: 'Project contributors table upsell state',
  bulkActions: 'Project bulk actions upsell modal',
  kanbanTasks: 'Kanban tasks upsell modal',
  clientsAndKanbanTasks: 'Clients and Kanban tasks upsell modal',
  schedule: 'Project Schedule upsell state',
  scheduleEmptyState: 'Project Schedule empty state',
  kanbanAndSchedule: 'Kanban tasks and Schedule upsell modal',
  projectSalesInvoices: 'Project sales invoices upsell modal',
  projectsDocuments: 'Project documents upsell modal',
}
